module.exports = __webpack_public_path__ + "img/favicon_liskobserver.a5a5dc9e.png";